import { createReducer } from '../../../utilities';
import {
    SUCCESS_FETCH_STATS_MATCHES_LINE_UP
} from "../../../../actions/entities/statistics/matches";

const initialState = {};

function successFetch(state, action) {
    const { data } = action;
    return {
        ...state,
        ...data,
    };
}

export default createReducer(initialState, {
    [SUCCESS_FETCH_STATS_MATCHES_LINE_UP]: successFetch,
});



// WEBPACK FOOTER //
// ./src/reducers/app/statistics/matches/lineUp.js